import Vue from 'vue'
import DYSelectCustomerDialog from '@/components/DYSelectCustomerDialog'
import DYSelectHouseDialog from '@/components/DYSelectHouseDialog'
import DYSelectCarportDialog from '@/components/DYSelectCarportDialog'
import DYSelectAccountDialog from '@/components/DYSelectAccountDialog'
import DYSelectConductDialog from '@/components/DYSelectConductDialog'
import DYLngLatSelectDialog from '@/components/DYLngLatSelectDialog'

const selects = {
  SelectCustomer: DYSelectCustomerDialog,
  SelectHouse: DYSelectHouseDialog,
  SelectCarport: DYSelectCarportDialog,
  SelectAccount: DYSelectAccountDialog,
  SelectConduct: DYSelectConductDialog,
  SelectLngLat: DYLngLatSelectDialog,
}

const componentRegister = function (app) {
  for (const key in selects) {
    const constructor = Vue.extend(selects[key])
    let instance
    const method = function (params) {
      return new Promise((resolve, reject) => {
        instance = new constructor()
        let el = instance.$mount().$el
        document.body.appendChild(el)
        instance.open({
          ...params,
          resolve: (data) => {
            resolve(data)
            document.body.removeChild(el)
            el = undefined
          },
          cancel: () => {
            el && document.body.removeChild(el)
            el = undefined
          }
        })
      })
    }
    app.prototype[`$${key}`] = method
  }
}

export default componentRegister
